import { inject, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError, map } from 'rxjs';
import { environment } from '@/environments/environment';
import { ResponseWithCode } from '../pages/action-token/interface/respose';

@Injectable({ providedIn: 'root' })
export class ActionTokenService {
  private http = inject(HttpClient);

  validateActionToken(token: string): Observable<ResponseWithCode> {
    const url = `${environment.apiGatewayUrl}/account/action-token`;

    return this.http.get(`${url}?key=${token}`, { observe: 'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if (response.status === 204) {
          return { status: 'NO_CONTENT' };
        }
        console.log(response.status)
        console.log("Service Token")
        console.log(JSON.stringify(response.body))
        console.log("response:")
        console.log(JSON.stringify(response))
        return response.body;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error validating token:', error);
        console.log('Error status code:', error.status);
        return this.handleError(error);
      })
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('Error en la solicitud:', error);
    return throwError(
      () =>
        'Error en la solicitud, por favor intente más tarde o contacte con el administrador.'
    );
  }
}
